import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import ControlLibrary from "@/pages/ControlLibrary";
import BreachDesk from "./pages/BreachDesk";
import IncidentIntake from "./pages/IncidentIntake";
import IncidentWorkspace from "./pages/IncidentWorkspace";
import ControlWorkspace from "@/pages/ControlWorkspace";
import ControlTest from "@/pages/ControlTest";
import Deficiency from "@/pages/Deficiency";
import ProtectedRoute from "@/components/ProtectedRoute";
import RightsRequests from "@/pages/RightsRequests";
import RightsRequestDetail from "@/pages/RightsRequestDetail";
import VendorRegister from "@/pages/VendorRegister";
import VendorProfile from "@/pages/VendorProfile";
import VendorAssessment from "@/pages/VendorAssessment";
import RetentionManager from "@/pages/RetentionManager";
import DispositionBatch from "@/pages/DispositionBatch";
import LegalHold from "@/pages/LegalHold";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import GRCDashboard from "@/pages/GRCDashboard";
import Admin from "@/pages/Admin";
import RoPARegister from "@/pages/RoPARegister";
import RoPARecordDetail from "@/pages/RoPARecordDetail";
import BoardMemo from "@/pages/BoardMemo";
import TaskCentre from "@/pages/TaskCentre";
import Approvals from "@/pages/Approvals";
import AuditLog from "@/pages/AuditLog";
import FileService from "@/pages/FileService";
import Notifications from "@/pages/Notifications";
import Settings from "@/pages/Settings";

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/assessment/:id/dashboard" element={<ProtectedRoute><GRCDashboard /></ProtectedRoute>} />
            <Route path="/assessment/:id/findings"    element={<ProtectedRoute><GRCDashboard /></ProtectedRoute>} />
            <Route path="/assessment/:id/controls"    element={<ProtectedRoute><GRCDashboard /></ProtectedRoute>} />
            <Route path="/assessment/:id/evidence"    element={<ProtectedRoute><GRCDashboard /></ProtectedRoute>} />
            <Route path="/assessment/:id/remediation" element={<ProtectedRoute><GRCDashboard /></ProtectedRoute>} />
            <Route path="/assessment/:id/team-raci"   element={<ProtectedRoute><GRCDashboard /></ProtectedRoute>} />
            <Route path="/assessment/:id/trend"       element={<ProtectedRoute><GRCDashboard /></ProtectedRoute>} />
            <Route path="/assessment/:id/ropa"            element={<ProtectedRoute><RoPARegister /></ProtectedRoute>} />
            <Route path="/assessment/:id/ropa/:recordId"  element={<ProtectedRoute><RoPARecordDetail /></ProtectedRoute>} />
            <Route path="/assessment/:id/board-memo"      element={<ProtectedRoute><BoardMemo /></ProtectedRoute>} />
            <Route path="/rights" element={<ProtectedRoute><RightsRequests /></ProtectedRoute>} />
            <Route path="/rights/:rid" element={<ProtectedRoute><RightsRequestDetail /></ProtectedRoute>} />
            <Route path="/vendors" element={<ProtectedRoute><VendorRegister /></ProtectedRoute>} />
            <Route path="/vendors/:vid" element={<ProtectedRoute><VendorProfile /></ProtectedRoute>} />
            <Route path="/vendors/:vid/assessments/:aid" element={<ProtectedRoute><VendorAssessment /></ProtectedRoute>} />
            <Route path="/retention" element={<ProtectedRoute><RetentionManager /></ProtectedRoute>} />
            <Route path="/retention/batches/:bid" element={<ProtectedRoute><DispositionBatch /></ProtectedRoute>} />
            <Route path="/retention/holds/:hid" element={<ProtectedRoute><LegalHold /></ProtectedRoute>} />
            <Route path="/controls" element={<ProtectedRoute><ControlLibrary /></ProtectedRoute>} />
            <Route path="/breach" element={<ProtectedRoute><BreachDesk /></ProtectedRoute>} />
            <Route path="/breach/new" element={<ProtectedRoute><IncidentIntake /></ProtectedRoute>} />
            <Route path="/breach/:iid" element={<ProtectedRoute><IncidentWorkspace /></ProtectedRoute>} />
            <Route path="/controls/tests/:tid" element={<ProtectedRoute><ControlTest /></ProtectedRoute>} />
            <Route path="/controls/deficiencies/:did" element={<ProtectedRoute><Deficiency /></ProtectedRoute>} />
            <Route path="/controls/:cid" element={<ProtectedRoute><ControlWorkspace /></ProtectedRoute>} />
            <Route path="/tasks" element={<ProtectedRoute><TaskCentre /></ProtectedRoute>} />
            <Route path="/approvals" element={<ProtectedRoute><Approvals /></ProtectedRoute>} />
            <Route path="/audit" element={<ProtectedRoute><AuditLog /></ProtectedRoute>} />
            <Route path="/files" element={<ProtectedRoute><FileService /></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </div>
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
